export class Video {
    constructor({id, title, description, url, duration, thumbnail, tags, createdAt, updatedAt, muted}) {
        this.id = id;
        this.title = title;
        this.description = description;
        this.url = url;
        this.duration = duration;
        this.thumbnail = thumbnail;
        this.tags = tags;
        this.createdAt = createdAt;
        this.updatedAt = updatedAt;
        this.muted = muted;
    };

    clone() {
        return new Video({
            id: this.id,
            title: this.title,
            description: this.description,
            url: this.url,
            duration: this.duration,
            thumbnail: this.thumbnail,
            tags: this.tags,
            createdAt: this.createdAt,
            updatedAt: this.updatedAt,
            muted: this.muted
        });
    };
}

export const videoConverter = {
    toFirestore() {
        return null;
    },
    fromFirestore(snapshot, options) {
        const data = snapshot.data(options);
        return new Video({
            id: snapshot.id,
            title: data.title,
            description: data.description || null,
            url: data.url,
            duration: data.duration || null,
            thumbnail: data.thumbnail || null,
            tags: data.tags || [],
            createdAt: data.created_at,
            updatedAt: data.updated_at,
            muted: true
        });
    }
};